import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useSiteContent } from '../hooks/useSiteContent';
import AvailabilitySummary from '../components/common/AvailabilitySummary';

const AboutPage: React.FC = () => {
  const c = useSiteContent();

  return (
    <div className="bg-cream">
      <Helmet>
        <title>About Ethan Langley — EJL Education</title>
        <meta name="description" content="Year 13 at Wilson's School, Hertford College Oxford offer-holder. Ten grade 9s at GCSE, DBS-checked." />
      </Helmet>
      {/* ─── Heading ───────────────────────────────────────────────────── */}
      <section className="section pt-24 md:pt-32">
        <div className="container-content max-w-[72ch]">
          <div className="flex items-center gap-4">
            <img src="/ejl-logo.png" alt="" className="w-10 h-10 object-contain" aria-hidden="true" />
            <h1>About me</h1>
          </div>

          <div className="mt-10 space-y-6 text-body text-ink/90">
            <p>
              {c('about_p1', "I'm Ethan. I'm in Year 13 at Wilson's School and I have an offer to read Philosophy, Politics and Economics at Hertford College, Oxford, starting this October.")}
            </p>
            <p>
              {c('about_p2', "At GCSE I got 10 grade 9s and one grade 8. I'm currently sitting A-levels in Maths, Further Maths, Economics, Philosophy and Politics. Every week I teach at TestTeach, an 11+ tutoring organisation, where I've worked with students across the full range of abilities and picked up the structured methods that good tutors actually use.")}
            </p>
            <p>
              {c('about_p3', "I passed the 11+ myself in 2019 with about three weeks of prep, which is partly why I believe in targeted, efficient revision over volume. Most students don't need more hours; they need the right hour.")}
            </p>
            <p>
              {c('about_p4', "Outside the classroom I debate for England at international level. I was 3rd best speaker in Europe at the European Schools Debating Championships. I've attended the John Locke Institute Summer School twice, in 2023 and 2024, both with High Commendation.")}
            </p>
          </div>
        </div>
      </section>

      {/* ─── Credentials row ───────────────────────────────────────────── */}
      <section className="border-t border-rule">
        <div className="container-content py-12 md:py-16">
          <div className="grid sm:grid-cols-2 gap-6 max-w-[72ch]">
            {/* TODO: {{NEEDS: Wilson's School crest SVG}} — replace text badge with crest asset when available. */}
            {/* NEEDS: Wilson's School crest SVG */}
            <div className="border border-rule rounded-card p-6 text-center">
              <p className="font-serif text-h3">Wilson's School</p>
              <p className="text-sm text-muted">South London grammar</p>
            </div>

            {/* TODO: {{NEEDS: Hertford College crest SVG}} — replace text badge with crest asset when available. */}
            {/* NEEDS: Hertford College crest SVG */}
            <div className="border border-rule rounded-card p-6 text-center">
              <p className="font-serif text-h3">Hertford College, Oxford</p>
              <p className="text-sm text-muted">PPE offer</p>
            </div>
          </div>
        </div>
      </section>

      {/* ─── Availability ──────────────────────────────────────────────── */}
      <section className="section border-t border-rule">
        <div className="container-content max-w-[72ch]">
          <AvailabilitySummary variant="panel" />
        </div>
      </section>

      {/* ─── Safeguarding ──────────────────────────────────────────────── */}
      <section className="section border-t border-rule">
        <div className="container-content max-w-[72ch]">
          <div className="card">
            <h2>{c('about_safeguarding_h', 'Safeguarding')}</h2>
            <p className="mt-5 text-body text-ink/90">
              {c('about_safeguarding_body', "I hold an enhanced DBS check and can share the certificate on request before the first session. Online sessions can be recorded if you request it in advance. Parents are welcome to sit in on any session, and most do for the first one.")}
            </p>
          </div>
        </div>
      </section>

      {/* ─── CTA ───────────────────────────────────────────────────────── */}
      <section className="pb-16 md:pb-24">
        <div className="container-content text-center">
          <Link to="/contact" className="btn btn-primary">
            Book a £5 20-minute call
          </Link>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;
